<template>
  <ul class="menu-nav">
    <li v-if="email==='manager@dorinsight.com' || email === 'admin@dorinsight.com' || email === 'admin@limonist.com'"
        aria-haspopup="true"
        data-menu-toggle="click"
        v-bind:class="{ 'menu-item-active': hasActiveChildren('/error/error') }"
        class="menu-item menu-item-submenu menu-item-open-dropdown"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="menu-icon flaticon-app"></i>
        <span class="menu-text"> {{ $t('menu.actions') }} </span>
      </a>
      <div class="menu-submenu menu-submenu-classic">
        <ul class="menu-subnav">
          <router-link
              to="/create-offer"
              v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">{{ $t('menu.create_new_offer') }}</span>
              </a>
            </li>
          </router-link>
          <router-link
              to="/offers"
              v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">{{ $t('menu.offers') }}</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>
    <li v-if="email==='manager@dorinsight.com' || email === 'admin@dorinsight.com' || email === 'admin@limonist.com'"
        aria-haspopup="true"
        data-menu-toggle="click"
        v-bind:class="{ 'menu-item-active': hasActiveChildren('/error/error') }"
        class="menu-item menu-item-submenu menu-item-open-dropdown"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="menu-icon flaticon-interface-1"></i>
        <span class="menu-text"> {{  $t('menu.definitions') }} </span>
      </a>
      <div class="menu-submenu menu-submenu-classic">
        <ul class="menu-subnav">
          <router-link
              to="/internal-tests"
              v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">{{ $t('menu.offer_tests') }}</span>
              </a>
            </li>
          </router-link>
          <router-link
              to="/customer-tests"
              v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">{{ $t('menu.offer_customer_tests') }}</span>
              </a>
            </li>
          </router-link>
          <router-link
              to="/user-groups"
              v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">{{ $t('menu.user_groups') }}</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>
    <li v-if="email==='napolyon@dorinsight.com' || email === 'admin@dorinsight.com' || email === 'admin@limonist.com'"
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item menu-item-submenu"
        v-bind:class="{ 'menu-item-open': hasActiveChildren('/wizard/wizard') }"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="menu-icon flaticon-users"></i>
        <span class="menu-text">{{  $t('menu.user_management') }}</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <router-link
              to="/user-management"
              v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">{{ $t('menu.users') }}</span>
              </a>
            </li>
          </router-link>
          <router-link
              to="/contact-requests"
              v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">{{ $t('menu.contact_requests') }}</span>
              </a>
            </li>
          </router-link>
          <router-link
              to="/bulk-point-actions"
              v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">{{ $t('menu.bulk_point_actions') }}</span>
              </a>
            </li>
          </router-link>
          <router-link
              to="/fraud-management"
              v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">{{ $t('menu.fraud_management') }}</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>
    <li v-if="email==='napolyon@dorinsight.com' || email === 'admin@dorinsight.com' || email === 'admin@limonist.com'"
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item menu-item-submenu"
        v-bind:class="{ 'menu-item-open': hasActiveChildren('/wizard/wizard') }"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="menu-icon flaticon-reply"></i>
        <span class="menu-text">{{  $t('menu.nap_transfer') }}</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <router-link
              to="/nap-transfer-campaigns"
              v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">{{ $t('menu.nap_transfer_campaigns') }}</span>
              </a>
            </li>
          </router-link>
          <router-link
              to="/promotion-codes"
              v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">{{ $t('menu.promotion_codes') }}</span>
              </a>
            </li>
          </router-link>
          <router-link
              to="/nap-transfer-requests"
              v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active'
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot">
                  <span></span>
                </i>
                <span class="menu-text">{{ $t('menu.nap_transfer_requests') }}</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "KTMenu",
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    }
  },
  data (){
    return {
      email : null,
      isActive : false,
      isExactActive : false,
      href : false,
      navigate : false,
    }
  },
  mounted() {
    this.email = localStorage.getItem('email')
  }
};
</script>
